import { postJson } from '#/utils/http/postJson';

import type { ApiUserUsername } from './types/ApiTypedId';

export async function apiFollowUser(username: ApiUserUsername): Promise<void> {
  return postJson(`/data/website/users/by-username/${username}/follow`);
}

export async function apiUnfollowUser(
  username: ApiUserUsername,
): Promise<void> {
  return postJson(`/data/website/users/by-username/${username}/unfollow`);
}

export async function apiBlockUser(username: ApiUserUsername): Promise<void> {
  return postJson(`/data/website/users/by-username/${username}/block`);
}

export async function apiUnblockUser(username: ApiUserUsername): Promise<void> {
  return postJson(`/data/website/users/by-username/${username}/unblock`);
}
